import type { SongRequest } from '../services/requests';
import type { DurationVerified, LibrarySong, SaveSongLinkEntry } from '../services/songMatchMemory';
import { isValidSongLinkKey, parseMusicLink } from './songLinks';

const MAX_DURATION_MS = 3_600_000;

export interface DurationWriteBackInput {
  request: Pick<SongRequest, 'id' | 'eventId' | 'platformLink' | 'linkLibraryKey'>;
  librarySong: LibrarySong | undefined;
  durationMs: number | null | undefined;
  verified: DurationVerified;
}

export function buildDurationWriteBack(input: DurationWriteBackInput): SaveSongLinkEntry | null {
  const { request, librarySong, verified } = input;
  if (verified !== 'exact' && verified !== 'approximate') return null;

  if (typeof input.durationMs !== 'number' || !Number.isFinite(input.durationMs)) return null;
  const durationMs = Math.round(input.durationMs);
  if (durationMs < 1 || durationMs > MAX_DURATION_MS) return null;

  const songKey = request.linkLibraryKey;
  if (!isValidSongLinkKey(songKey)) return null;

  const link = request.platformLink;
  if (!link) return null;
  const parsed = parseMusicLink(link);
  if (parsed.kind !== 'track') return null;

  const libraryLink = librarySong?.links[parsed.provider];
  if (!libraryLink || libraryLink.trackId !== parsed.trackId) return null;

  if (libraryLink.durationVerified === 'exact' && verified === 'approximate') return null;
  if (libraryLink.durationMs === durationMs && libraryLink.durationVerified === verified) return null;

  return {
    songKey,
    link,
    durationMs,
    durationVerified: verified,
    eventId: request.eventId,
    requestId: request.id,
  };
}
